import request from '../utils/request';

export default {
  // 首页
  homeIndex: query => {
    return request({
      url: '/pms/plat/home/index',
      method: 'get',
      params: query,
    });
  },

  // 房东每日数据统计
  homeCompany: query => {
    return request({
      url: '/pms/plat/home/company',
      method: 'get',
      params: query,
    });
  },
  // 房东每日数据统计-导出
  homeExport: query => {
    return request({
      url: '/pms/plat/home/export',
      method: 'get',
      params: query,
    });
  },
  // 数据分析-报表
  dateAnalysis: query => {
    return request({
      url: '/pms/plat/home/analysis',
      method: 'get',
      params: query,
    });
  },
  //房东列表
  landlordList: query => {
    return request({
      url: 'pms/plat/company/list',
      method: 'get',
      params: query,
    });
  },
  //房东统计数据更新
  landlordStatis: query => {
    return request({
      url: 'pms/plat/company/updateStatis',
      method: 'post',
      data: query,
    });
  },
  //房东管理-设置临时密码
  landlordSetPwd: query => {
    return request({
      url: 'pms/plat/company/setPwd',
      method: 'post',
      data: query,
    });
  },
  //房东管理-房东注销
  landlordCancel: query => {
    return request({
      url: 'pms/plat/company/cancel',
      method: 'post',
      data: query,
    });
  },
  //房东配置列表
  landlordConfigList: query => {
    return request({
      url: 'pms/plat/company/configList',
      method: 'get',
      params: query,
    });
  },
  //房东配置列表
  landlordConfigSave: query => {
    return request({
      url: 'pms/plat/company/configSave',
      method: 'post',
      data: query,
    });
  },

  // 员工列表
  staffList: query => {
    return request({
      url: 'pms/plat/staff/list',
      method: 'get',
      params: query,
    });
  },

  // 房型列表
  roomList: query => {
    return request({
      url: 'pms/plat/room/list',
      method: 'get',
      params: query,
    });
  },

  // 房间管理
  houseList: query => {
    return request({
      url: 'pms/plat/house/list',
      method: 'get',
      params: query,
    });
  },

  // 房间管理-是否允许设置密码
  houseSetPwd: query => {
    return request({
      url: 'pms/plat/house/setPwd',
      method: 'post',
      data: query,
    });
  },
  // 房间管理-安装设置
  houseSetInstall: query => {
    return request({
      url: 'pms/plat/house/setInstall',
      method: 'post',
      data: query,
    });
  },
  // 授权配置列表
  platOpenList: query => {
    return request({
      url: 'pms/plat/open/list',
      method: 'get',
      params: query,
    });
  },

  // 授权配置列表——添加
  platOpenAdd: query => {
    return request({
      url: 'pms/plat/open/add',
      method: 'post',
      data: query,
    });
  },

  // 授权配置列表——修改
  platOpenEdit: query => {
    return request({
      url: 'pms/plat/open/edit',
      method: 'post',
      data: query,
    });
  },

  // 授权配置列表——修改
  platOpenDetails: query => {
    return request({
      url: 'pms/plat/open/details',
      method: 'get',
      params: query,
    });
  },

  // 授权配置列表——删除
  platOpenDel: query => {
    return request({
      url: 'pms/plat/open/del',
      method: 'post',
      data: query,
    });
  },

  // 授权配置列表——更改平台状态
  platOpenUpdateStatus: query => {
    return request({
      url: 'pms/plat/open/updateStatus',
      method: 'post',
      data: query,
    });
  },

  // 获取苏安码配置
  platJsmonitorGetConfig: query => {
    return request({
      url: 'pms/plat/monitor/jsMonitor/getConfig',
      method: 'get',
      params: query,
    });
  },
  // 保存苏安码配置
  platJsmonitorSaveConfig: query => {
    return request({
      url: 'pms/plat/monitor/jsMonitor/saveConfig',
      method: 'post',
      data: query,
    });
  },
  // 苏安码上报列表
  platJsmonitorAreaList: query => {
    return request({
      url: 'pms/plat/monitor/jsMonitor/areaList',
      method: 'get',
      params: query,
    });
  },
  // 更新苏安码上报列表状态
  platJsmonitorStatus: query => {
    return request({
      url: 'pms/plat/monitor/jsMonitor/areaStatus',
      method: 'post',
      data: query,
    });
  },
  // 添加苏安码上报
  platJsmonitorAdd: query => {
    return request({
      url: 'pms/plat/monitor/jsMonitor/areaAdd',
      method: 'post',
      data: query,
    });
  },
  // 删除上报
  platJsmonitorDel: query => {
    return request({
      url: 'pms/plat/monitor/jsMonitor/areaDel',
      method: 'post',
      data: query,
    });
  },
  // ota关系配置列表
  platJsmonitorOtaList: query => {
    return request({
      url: 'pms/plat/monitor/jsMonitor/otaList',
      method: 'get',
      params: query,
    });
  },
  // 更新ota关系
  platJsmonitorOtaRela: query => {
    return request({
      url: 'pms/plat/monitor/jsMonitor/otaRela',
      method: 'post',
      data: query,
    });
  },
  // 更新ota状态
  platJsmonitorOtaStatus: query => {
    return request({
      url: 'pms/plat/monitor/jsMonitor/otaStatus',
      method: 'post',
      data: query,
    });
  },
  // 获取网约房平台列表
  platJsmonitorPlatList: query => {
    return request({
      url: 'pms/plat/monitor/jsMonitor/platList',
      method: 'get',
      params: query,
    });
  },
  // 经营者数据上报列表
  platJsmonitorGetCompanyList: query => {
    return request({
      url: 'pms/plat/monitor/jsMonitor/getCompanyList',
      method: 'get',
      params: query,
    });
  },
  // 订单上报列表
  platJsmonitorGetCheckInList: query => {
    return request({
      url: 'pms/plat/monitor/jsMonitor/getCheckInList',
      method: 'get',
      params: query,
    });
  },
  // 开门记录上报列表
  platJsmonitorGetOpenDoorList: query => {
    return request({
      url: 'pms/plat/monitor/jsMonitor/getOpenDoorList',
      method: 'get',
      params: query,
    });
  },
  // 入住人信息上报列表
  platJsmonitorGetTenantList: query => {
    return request({
      url: 'pms/plat/monitor/jsMonitor/getTenantList',
      method: 'get',
      params: query,
    });
  },
  // 门锁安装记录上报列表
  platJsmonitorGetLockList: query => {
    return request({
      url: 'pms/plat/monitor/jsMonitor/getLockList',
      method: 'get',
      params: query,
    });
  },
  // 房源上报列表
  platJsmonitorGetHouseList: query => {
    return request({
      url: 'pms/plat/monitor/jsMonitor/getHouseList',
      method: 'get',
      params: query,
    });
  },
  // 同步
  platJsmonitorPlatSyn: query => {
    return request({
      url: 'pms/plat/monitor/jsMonitor/platSyn',
      method: 'get',
      params: query,
    });
  },

  // 获取国泰配置
  platGuoTaiMonitorGetConfig: query => {
    return request({
      url: 'pms/plat/monitor/GuoTaiMonitor/getConfig',
      method: 'get',
      params: query,
    });
  },
  // 保存国泰配置
  platGuoTaiMonitorSaveConfig: query => {
    return request({
      url: 'pms/plat/monitor/GuoTaiMonitor/saveConfig',
      method: 'post',
      data: query,
    });
  },
  // 国泰上报区域列表
  platGuoTaiMonitorAreaList: query => {
    return request({
      url: 'pms/plat/monitor/GuoTaiMonitor/areaList',
      method: 'get',
      params: query,
    });
  },
  // 更新国泰上报区域列表状态
  platGuoTaiMonitorStatus: query => {
    return request({
      url: 'pms/plat/monitor/GuoTaiMonitor/areaStatus',
      method: 'post',
      data: query,
    });
  },
  // 添加国泰区域上报
  platGuoTaiMonitorAdd: query => {
    return request({
      url: 'pms/plat/monitor/GuoTaiMonitor/areaAdd',
      method: 'post',
      data: query,
    });
  },
  // 删除国泰上报区域
  platGuoTaiMonitorDel: query => {
    return request({
      url: 'pms/plat/monitor/GuoTaiMonitor/areaDel',
      method: 'post',
      data: query,
    });
  },
  // 国泰房源列表
  platGuoTaiMonitorOperatorList: query => {
    return request({
      url: 'pms/plat/monitor/GuoTaiMonitor/operatorList',
      method: 'get',
      params: query,
    });
  },
  // 国泰房源列表
  platGuoTaiMonitorHouseList: query => {
    return request({
      url: 'pms/plat/monitor/GuoTaiMonitor/houseList',
      method: 'get',
      params: query,
    });
  },
  // 国泰房源列表
  platGuoTaiMonitorOrderList: query => {
    return request({
      url: 'pms/plat/monitor/GuoTaiMonitor/orderList',
      method: 'get',
      params: query,
    });
  },
  // 国泰未登记列表
  platGuoTaiUnRecordHouse: query => {
    return request({
      url: 'pms/plat/monitor/GuoTaiMonitor/unRecordHouse',
      method: 'get',
      params: query,
    });
  },
  // 生成登记批次号
  platGuoTaiAddRecord: query => {
    return request({
      url: 'pms/plat/monitor/GuoTaiMonitor/addRecord',
      method: 'post',
      data: query,
    });
  },
  // 生成登记批次号
  platGuoTaiRecordList: query => {
    return request({
      url: 'pms/plat/monitor/GuoTaiMonitor/recordList',
      method: 'get',
      params: query,
    });
  },
  // 生成登记批次号
  platGuoTaiRecordExport: query => {
    return request({
      url: 'pms/plat/monitor/GuoTaiMonitor/exportRecord',
      method: 'post',
      data: query,
    });
  },
  // 国泰房源上报
  platGuoTaiMonitorCheckin: query => {
    return request({
      url: 'pms/plat/monitor/GuoTaiMonitor/checkin',
      method: 'get',
      params: query,
    });
  },
  // 国泰退房记录
  platGuoTaiMonitorCheckout: query => {
    return request({
      url: 'pms/plat/monitor/GuoTaiMonitor/checkout',
      method: 'get',
      params: query,
    });
  },
  // 国泰开门记录
  platGuoTaiMonitorUnlock: query => {
    return request({
      url: 'pms/plat/monitor/GuoTaiMonitor/unlock',
      method: 'get',
      params: query,
    });
  },

  // 获取提现配置
  getWithdrawalConfig: query => {
    return request({
      url: 'pms/plat/withdrawal/getConfig',
      method: 'get',
      params: query,
    });
  },
  // 保存提现配置
  saveWithdrawalConfig: query => {
    return request({
      url: 'pms/plat/withdrawal/saveConfig',
      method: 'post',
      data: query,
    });
  },
  // 提现列表
  withdrawalList: query => {
    return request({
      url: 'pms/plat/withdrawal/list',
      method: 'get',
      params: query,
    });
  },
  // 更新记录
  updateWithdrawal: query => {
    return request({
      url: 'pms/plat/withdrawal/update',
      method: 'post',
      data: query,
    });
  },
  // 提现详情
  withdrawalDetails: query => {
    return request({
      url: 'pms/plat/withdrawal/details',
      method: 'get',
      params: query,
    });
  },
  // 房东钱包
  moneyBagList: query => {
    return request({
      url: 'pms/plat/money/list',
      method: 'get',
      params: query,
    });
  },
  // 钱包明细日志
  moneyBagLogList: query => {
    return request({
      url: 'pms/plat/money/log',
      method: 'get',
      params: query,
    });
  },
  // 钱包明细日志-导出
  moneyBagLogExport: query => {
    return request({
      url: 'pms/plat/money/logExport',
      method: 'get',
      params: query,
      responseType: 'blob',
      timeout: 120000,
    });
  },
  // 各门店钱包收入 & 提现
  storeIncome: query => {
    return request({
      url: 'pms/plat/money/storeIncome',
      method: 'get',
      params: query,
    });
  },
  // 单个门店下各房间的钱包收入
  roomIncome: query => {
    return request({
      url: 'pms/plat/money/roomIncome',
      method: 'get',
      params: query,
    });
  },
  // 门店选项列表（先选公司，再选门店）
  proxyStoreSelectOption: query => {
    return request({
      url: 'pms/plat/proxy/store/selectOption',
      method: 'get',
      params: query,
    });
  },
  // 房东费用
  feeList: query => {
    return request({
      url: 'pms/plat/fee/list',
      method: 'get',
      params: query,
    });
  },
  // 房东费用明细
  feeLog: query => {
    return request({
      url: 'pms/plat/fee/log',
      method: 'get',
      params: query,
    });
  },

  // 云掌柜-获取配置
  yunZhangGuiGetConfig: query => {
    return request({
      url: 'pms/plat/yunzhanggui/config/getConfig',
      method: 'get',
      params: query,
    });
  },
  // 云掌柜-保存配置
  yunZhangGuiSaveConfig: query => {
    return request({
      url: 'pms/plat/yunzhanggui/config/saveConfig',
      method: 'post',
      data: query,
    });
  },
  // 云掌柜-校验配置
  yunZhangGuiCheckConfig: query => {
    return request({
      url: 'pms/plat/yunzhanggui/config/checkConfig',
      method: 'post',
      data: query,
    });
  },
  // 云掌柜-获取酒店列表
  yunZhangGuiGetHotelList: query => {
    return request({
      url: 'pms/plat/yunzhanggui/hotel/list',
      method: 'get',
      params: query,
    });
  },
  // 云掌柜-同步酒店数据
  yunZhangGuiSyncHotel: query => {
    return request({
      url: 'pms/plat/yunzhanggui/hotel/syncHotel',
      method: 'post',
      data: query,
    });
  },
  // 云掌柜-酒店关系修改
  yunZhangGuiHotelEdit: query => {
    return request({
      url: 'pms/plat/yunzhanggui/hotel/edit',
      method: 'post',
      data: query,
    });
  },
  // 云掌柜-酒店删除
  yunZhangGuiHotelDel: query => {
    return request({
      url: 'pms/plat/yunzhanggui/hotel/del',
      method: 'post',
      data: query,
    });
  },
  // 云掌柜-账号列表
  yunZhangGuiRegisterList: query => {
    return request({
      url: 'pms/plat/yunzhanggui/register/list',
      method: 'get',
      params: query,
    });
  },
  // OTA-获取账号选项列表
  otaGetOptionList: query => {
    return request({
      url: 'pms/plat/ota/account/optionList',
      method: 'get',
      params: query,
    });
  },

  // 获取提现配置
  getBaseConfig: query => {
    return request({
      url: 'pms/plat/config/getConfig',
      method: 'get',
      params: query,
    });
  },
  // 保存提现配置
  saveBaseConfig: query => {
    return request({
      url: 'pms/plat/config/saveConfig',
      method: 'post',
      data: query,
    });
  },

  //江苏常州上报
  // 江苏常州-获取配置
  PmsChangZhouGetConfig: query => {
    return request({
      url: 'pms/plat/changzhou/getConfig',
      method: 'get',
      params: query,
    });
  },
  // 江苏常州-配置保存
  PmsChangZhouSaveConfig: query => {
    return request({
      url: 'pms/plat/changzhou/saveConfig',
      method: 'post',
      data: query,
    });
  },
  // 江苏常州-上报区域
  PmsChangZhouAreaList: query => {
    return request({
      url: 'pms/plat/changzhou/areaList',
      method: 'get',
      params: query,
    });
  },
  // 江苏常州-区域状态变更
  PmsChangZhouAreaStatus: query => {
    return request({
      url: 'pms/plat/changzhou/areaStatus',
      method: 'post',
      data: query,
    });
  },
  // 江苏常州-添加区域
  PmsChangZhouAreaAdd: query => {
    return request({
      url: 'pms/plat/changzhou/areaAdd',
      method: 'post',
      data: query,
    });
  },
  // 江苏常州区域删除
  PmsChangZhouAreaDel: query => {
    return request({
      url: 'pms/plat/changzhou/areaDel',
      method: 'post',
      data: query,
    });
  },

  // 江苏常州-经营者列表
  platChangZhouOperator: query => {
    return request({
      url: 'pms/plat/changzhou/operator',
      method: 'get',
      params: query,
    });
  },
  // 江苏常州-房源列表
  platChangZhouHouse: query => {
    return request({
      url: 'pms/plat/changzhou/house',
      method: 'get',
      params: query,
    });
  },
  // 江苏常州-订单
  platChangZhouOrder: query => {
    return request({
      url: 'pms/plat/changzhou/order',
      method: 'get',
      params: query,
    });
  },
  // 江苏常州-入住登记
  platChangZhouCheckin: query => {
    return request({
      url: 'pms/plat/changzhou/checkin',
      method: 'get',
      params: query,
    });
  },
  // 江苏常州-开门记录
  platChangZhouOpen: query => {
    return request({
      url: 'pms/plat/changzhou/unlock',
      method: 'get',
      params: query,
    });
  },

  // 押金单
  PmsOrderDepositList: query => {
    return request({
      url: 'pms/plat/order/deposit',
      method: 'get',
      params: query,
    });
  },

  //强制退款接口(直接走腾讯接口退款，不改变数据库状态)
  ForceRefund: query => {
    return request({
      url: 'pms/plat/wxRefund/forceRefund',
      method: 'post',
      data: query,
    });
  },

  // 收费项目管理
  chargeItemGetList: query => {
    return request({
      url: 'pms/plat/chargeItem/getList',
      method: 'get',
      params: query,
    });
  },
  chargeItemUpdate: query => {
    return request({
      url: 'pms/plat/chargeItem/update',
      method: 'post',
      data: query,
    });
  },

  // 身份证OCR配置
  idcardocrGetConfig: query => {
    return request({
      url: 'system/idcardocr/getConfig',
      method: 'get',
      params: query,
    });
  },
  idcardocrSaveConfig: query => {
    return request({
      url: 'system/idcardocr/saveConfig',
      method: 'post',
      data: query,
    });
  },

  // 人脸与身份证比对配置
  faceidcardGetConfig: query => {
    return request({
      url: 'system/faceidcard/getConfig',
      method: 'get',
      params: query,
    });
  },
  faceidcardSaveConfig: query => {
    return request({
      url: 'system/faceidcard/saveConfig',
      method: 'post',
      data: query,
    });
  },

  // 租客核验计次卡-商品列表
  tenantVerifyPackageGetList: query => {
    return request({
      url: 'pms/plat/tenantVerifyPackage/getList',
      method: 'get',
      params: query,
    });
  },
  // 租客核验计次卡-商品详情
  tenantVerifyPackageDetails: query => {
    return request({
      url: 'pms/plat/tenantVerifyPackage/details',
      method: 'get',
      params: query,
    });
  },
  // 租客核验计次卡-添加商品
  tenantVerifyPackageAdd: query => {
    return request({
      url: 'pms/plat/tenantVerifyPackage/add',
      method: 'post',
      data: query,
    });
  },
  // 租客核验计次卡-编辑商品
  tenantVerifyPackageEdit: query => {
    return request({
      url: 'pms/plat/tenantVerifyPackage/edit',
      method: 'post',
      data: query,
    });
  },
  // 租客核验计次卡-删除商品
  tenantVerifyPackageDel: query => {
    return request({
      url: 'pms/plat/tenantVerifyPackage/del',
      method: 'post',
      data: query,
    });
  },
  // 租客核验计次卡-改状态
  tenantVerifyPackageUpdateStatus: query => {
    return request({
      url: 'pms/plat/tenantVerifyPackage/updateStatus',
      method: 'post',
      data: query,
    });
  },
  // 锁具预审-列表
  lockPreList: query => {
    return request({
      url: 'device/plat/ttlockPre/platList',
      method: 'get',
      params: query,
    });
  },
  // 锁具预审-添加平台锁
  lockPreAdd: query => {
    return request({
      url: 'device/plat/ttlockPre/addLock',
      method: 'post',
      data: query,
    });
  },
  // 锁具预审-审核房东申请
  lockPreAudit: query => {
    return request({
      url: 'device/plat/ttlockPre/applyAudit',
      method: 'post',
      data: query,
    });
  },
  // 锁具审核员-列表
  lockAuditorList: query => {
    return request({
      url: 'device/plat/lockAuditor/list',
      method: 'get',
      params: query,
    });
  },
  // 锁具审核员-候选用户列表（添加弹窗远程搜索）
  lockAuditorUserList: query => {
    return request({
      url: 'device/plat/lockAuditor/userList',
      method: 'get',
      params: query,
    });
  },
  // 锁具审核员-新增
  lockAuditorAdd: query => {
    return request({
      url: 'device/plat/lockAuditor/add',
      method: 'post',
      data: query,
    });
  },
  // 锁具审核员-删除（软删除）
  lockAuditorDel: query => {
    return request({
      url: 'device/plat/lockAuditor/del',
      method: 'post',
      data: query,
    });
  },
};
